import React from 'react';
import { FieldMultiSelect } from '../../../components';
import { Field } from 'react-final-form';
import { divisionSchoolOptions, proTeamsOptions } from '../../../config/configExtras';
import { sortOptionsByKeyIntl } from '../../../util/genericHelpers';
import css from './SignupForm.module.css';

const FanTeamSelection = ({ formId, validate, intl }) => {
  const favoriteCollegiateOptions = sortOptionsByKeyIntl(
    divisionSchoolOptions.map(({ school }) => ({ label: school, value: school })),
    'label'
  );

  return (
    <div className={css.agencySelectWrapper}>
      <Field
        component={FieldMultiSelect}
        isMulti={true}
        id={formId ? `${formId}.${'favoriteCollegiateTeams'}` : 'favoriteCollegiateTeams'}
        name={'favoriteCollegiateTeams'}
        label={intl.formatMessage({
          id: 'SignupForm.favoriteCollegiateTeams.label',
        })}
        options={favoriteCollegiateOptions}
        {...validate}
      />
      <Field
        component={FieldMultiSelect}
        isMulti={true}
        id={formId ? `${formId}.${'favoriteProTeams'}` : 'favoriteProTeams'}
        name={'favoriteProTeams'}
        label={intl.formatMessage({
          id: 'SignupForm.FavoriteProfessionalTeamsSelector.label',
        })}
        options={sortOptionsByKeyIntl(proTeamsOptions, 'label')}
        {...validate}
      />
    </div>
  );
};
export default FanTeamSelection;
